import AuthService from "@/services/AuthService";

const state = {
    loginSuccess: false,
    loginErrorMsg: '',
    token: localStorage.getItem("_token"),
    userCode: localStorage.getItem("_usercode"),
    userDetail: {}
}

const getters = {
  userCode: state => {
    return state.userCode
  },
  userDetail: state => {
    return state.userDetail
  }
}

const mutations = {
  LOGIN(state, {success, msgErr}){
    state.loginSuccess = success
    state.loginErrorMsg = success ? '' : msgErr
  },
  SET_TOKEN(state, {token, userCode}){
    state.token = token
    state.userCode = userCode
  },
  SET_USER_DETAIL(state, { userDetail }) {
    state.userDetail = userDetail
  }
}

const actions = {
  async login({commit}, {username, password}){
    let loginSuccess = false, errorMsg = ''
    
    await AuthService.login(username, password)
        .then( response => {
            
            let respData = response.data;
            console.log(respData)
            if (respData.success  && respData._token != "" ) {
              loginSuccess = true
              localStorage._token = respData.token
              localStorage._usercode = username
              commit("SET_TOKEN", { token : respData.token, userCode: username} )
            } else {
              loginSuccess = false
              errorMsg = "Username or password is wrong !"
            }
            
        })
        .catch(err => {
          loginSuccess = false
          errorMsg = "login fail"
        })
    
    await commit("LOGIN", {success: loginSuccess, msgErr: errorMsg})
    
    
  },
  setToken(){
    
  },
  async getUserDetail({commit}) {
    await AuthService.userInfo()
    .then(response => {
      //console.log(response)
      if (response.success) {
        commit("SET_USER_DETAIL", { userDetail : response.user })
      }
    })
    .catch(err => {
      console.log(err)
    })

  }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }